import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { SupplierModel, SuppliersSearchParams} from '../shared/objects/suppliers';
import { SolutionModel, TypesOnSolutionHelper } from 'app/shared/objects/solutions';
import { IndicatorAdminHelper } from 'app/shared/objects/cities';
import { ListServices, AutoCompleteHelper, UpdatePictureResultHelper } from 'app/shared/objects/main';
import { SolutionFilterHelper } from 'app/shared/services/forms.service';

@Injectable()
export class AdminService {

    constructor(private http: HttpClient) {}

    postSolution(solution: SolutionModel): Promise<SolutionModel> {
            return this.http.post(environment.apiURL + '/admin/solution', solution)
                .toPromise()
                .then(response => response)
                .catch(error => {
                    return null;
                });
    }

    postSupplier(supplier: SupplierModel): Promise<SupplierModel> {
        return this.http.post(environment.apiURL + '/admin/supplier', supplier)
            .toPromise()
            .then(response => response)
            .catch(error => {
                return null;
            });
    }

    getSolution(id: string): Promise<SolutionModel> {
            return this.http.get(environment.apiURL + '/admin/solution/' + id)
                .toPromise()
                .then(response => {
                    return response as SolutionModel;
                })
                .catch(error => {
                    return null;
                });
    }

    getSolutions(params: SolutionFilterHelper): Promise<ListServices> {
        return this.http.post(environment.apiURL + '/admin/solutions', params)
        .toPromise()
        .then( response => response)
        .catch(error => {
            return null;
        });
    }

    getSupplier(id: string): Promise<SupplierModel> {
            return this.http.get(environment.apiURL + '/admin/supplier/' + id)
                .toPromise()
                .then(response => {
                    return response as SupplierModel;
                })
                .catch(error => {
                    return null;
                });
    }

    getSuppliers(params: SuppliersSearchParams): Promise<ListServices> {
        return this.http.post(environment.apiURL + '/admin/suppliers', params)
        .toPromise()
        .then( response => response)
        .catch(error => {
            return null;
        });
    }

    getIndicators(): Promise<IndicatorAdminHelper[]> {
        return this.http.get(environment.apiURL + '/admin/indicators')
        .toPromise()
        .then( response => response)
        .catch(error => {
            return null;
        });
    }

    getSuppliersSearch(search: string): Promise<AutoCompleteHelper[]> {
        return this.http.get(environment.apiURL + '/admin/suppliers/' + search)
            .toPromise()
            .then(response => {
                return response as AutoCompleteHelper[];
            })
            .catch(error => {
                return null;
            });
    }

    getTypeSolution(): Promise<TypesOnSolutionHelper> {
        return this.http.get(environment.apiURL + '/admin/typesOnSolution')
            .toPromise()
            .then(response => {
                return response as TypesOnSolutionHelper;
            })
            .catch(error => {
                return null;
            });
    }

    getTypeSupplier(): Promise<string[]> {
        return this.http.get(environment.apiURL + '/admin/typesOnSupplier')
            .toPromise()
            .then(response => {
                return response as string[];
            })
            .catch(error => {
                return null;
            });
    }

    getUpdatePictures(type: string): Promise<UpdatePictureResultHelper> {
        return this.http.get(environment.apiURL + '/admin/uploadImageToS3' + type)
            .toPromise()
            .then(response => {
                return response as UpdatePictureResultHelper;
            })
            .catch(error => {
                return null;
            });
    }


    getIndicatorList(): Promise<IndicatorAdminHelper[]> {
        return this.http.get(environment.apiURL + '/admin/indicators')
            .toPromise()
            .then(response => {
                return response as IndicatorAdminHelper[];
            })
            .catch(error => {
                return null;
            });
    }

    getGenarateLink(cityId: string): Promise<string[]> {
        return this.http.get(environment.apiURL + '/admin/buildIndicatorLinks/' + cityId)
            .toPromise()
            .then(response => {
                return response as string[];
            })
            .catch(error => {
                return null;
            });
    }

    postIndicatorsUpdate(data) {
        return this.http.post(environment.apiURL + '/admin/indicatorsUpdate', data)
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(error => {
                return null;
            })
    }
}
